"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataProcessing = void 0;
var translation_1 = __importDefault(require("../../../translation"));
var lodash_1 = require("lodash");
var DataProcessing = /** @class */ (function () {
    function DataProcessing() {
    }
    // private readonly _ExtraValues: {
    //   [type: string]: (object: Object) => string | undefined;
    // } = {
    //   dateOfBirthDD: (obj) =>
    //     this.extractFromStringValue('dateOfBirth', obj, /-(\d\d)$/),
    //   dateOfBirthMM: (obj) =>
    //     this.extractFromStringValue('dateOfBirth', obj, /-(\d\d)-/),
    //   dateOfBirthYYYY: (obj) =>
    //     this.extractFromStringValue('dateOfBirth', obj, /^(\d{4})-/),
    // }; //TODO change keys
    // private readonly _NameMapping = {
    //   accountHolder: "bankAccount.accountHolder",
    //   bankName: "bankAccount.bankName",
    //   bic: "bankAccount.bic",
    //   iban: "bankAccount.iban",
    // }
    DataProcessing.prototype.fillDataGet = function (parent, object) {
        $(parent)
            .find('[data-get]')
            .each(function (i, element) {
            var key = $(element).attr('data-get');
            var value = translation_1.default.t((0, lodash_1.get)(object, key));
            // if (!(typeof value === "string")) {
            //   let func = this._ExtraValues[key];
            //   if (func) value = func(object);
            // }
            if (value !== null) {
                if ($(element).is("input[type='text']")) {
                    $(element).val(value);
                }
                else if ($(element).is("input[type='radio']")) {
                    if ($(element).val() == value) {
                        $(element).prop('checked', true);
                    }
                }
                else if ($(element).is('img')) {
                    $(element).attr('src', value);
                }
                else {
                    $(element).html(value); // for all others?
                }
            }
            else {
                console.log("Property '" +
                    key +
                    "' does not exist or is null. Available properties are:" +
                    (0, lodash_1.keys)(object).filter(function (availableKey) { return typeof (0, lodash_1.get)(object, availableKey) !== null; }).join(', ')
                // + ', ' +
                // Object.keys(this._ExtraValues).join(', ')
                );
            }
        });
    };
    DataProcessing.prototype.mapDataAction = function (parent, actionMapping) {
        //remove old event listeners
        $(parent).find('[data-action="submit"]').off();
        $(parent)
            .find('[data-action]')
            .on('click', function (event) {
            var action = actionMapping[$(event.currentTarget).attr('data-action')];
            if (action) {
                action(event);
            }
            else {
                console.error("The action ".concat($(event.currentTarget).attr('data-action'), " does not have an implementation"));
            }
        });
    };
    DataProcessing.prototype.extractFromStringValue = function (key, object, regex) {
        var value = object[key];
        if (typeof value === 'string') {
            var matches = value.match(regex);
            return matches[1] || matches[0];
        }
        else {
            console.log("Property '" + key + "' does not exist, or isn't a string.");
            return undefined;
        }
    };
    return DataProcessing;
}());
exports.DataProcessing = DataProcessing;
